import { bindActionCreators } from '@reduxjs/toolkit'
import { authActions } from '@store/auth/auth.slice'
import { globalActions } from '@store/global/global.slice'
import { useAppDispatch } from '@store/hooks'

const actions = {
  ...authActions,
  ...globalActions,
}

export const useActions = () => {
  const dispatch = useAppDispatch()
  return bindActionCreators(actions, dispatch)
}
